import React from 'react';
import loadable from '@loadable/component';
import {
  addOnsOnEnterSaga,
  plansOnEnterSaga,
  settingsOnEnterSaga,
  updateOnEnterSaga,
} from 'features/Settings/settings.onenter.saga';

const AccountSettingsContainer = loadable(() => import('features/Settings/Account/AccountSettingsContainer'));
const BillingContainer = loadable(() => import('features/Settings/Billing/BillingContainer'));
const BundlesContainer = loadable(() => import('features/Settings/Membership/Bundles/BundlesContainer'));
const CancelContainer = loadable(() => import('features/Settings/Membership/Cancel/CancelContainer'));
const ChangePassword = loadable(() => import('features/Settings/ChangePassword/ChangePassword'));
const ContactSettingsContainer = loadable(() => import('features/Settings/Contact/ContactSettingsContainer'));
const HoldContainer = loadable(() => import('features/Settings/Membership/Hold/HoldContainer'));
const MembershipContainer = loadable(() => import('features/Settings/Membership/MembershipContainer'));
const PlansContainer = loadable(() => import('features/Settings/Membership/Plans/PlansContainer'));
const RecentChargesContainer = loadable(() => import('features/Settings/RecentCharges/RecentChargesContainer'));
const SettingsContainer = loadable(() => import('features/Settings/SettingsContainer'));
const UpdateContainer = loadable(() => import('features/Settings/Membership/Update/UpdateContainer'));

export const SettingsRoute = (store, client) => ({
  path: '/settings',

  onEnter: (nextState, replaceState, cb) =>
    store
      .runSagaOnce(settingsOnEnterSaga, client, nextState, replaceState)
      .toPromise()
      .then(cb, cb),

  component: props => <SettingsContainer {...props} />,

  childRoutes: [
    {
      path: 'add-ons',
      component: props => <BundlesContainer {...props} />,
      onEnter: (nextState, replaceState, cb) =>
        store
          .runSagaOnce(addOnsOnEnterSaga, client, replaceState, nextState)
          .toPromise()
          .then(cb, cb),
    },
    {
      path: 'contact',
      component: props => <ContactSettingsContainer {...props} />,
    },
    {
      path: 'charges',
      component: props => <RecentChargesContainer {...props} />,
    },
    {
      path: 'membership(/offer)',
      component: props => <MembershipContainer {...props} />,
    },
    {
      path: 'membership/update/hold',
      component: props => <HoldContainer {...props} />,
    },
    {
      path: 'membership/update/cancel',
      component: props => <CancelContainer {...props} />,
    },
    {
      path: 'membership/update',
      component: props => <UpdateContainer {...props} />,
      onEnter: (nextState, replaceState, cb) =>
        store
          .runSagaOnce(updateOnEnterSaga, client, replaceState, nextState)
          .toPromise()
          .then(cb, cb),
    },
    {
      path: 'plans',
      component: props => <PlansContainer {...props} />,
      onEnter: (nextState, replaceState, cb) =>
        store
          .runSagaOnce(plansOnEnterSaga, client, replaceState, nextState)
          .toPromise()
          .then(cb, cb),
    },
    {
      path: 'billing(/update)',
      component: props => <BillingContainer {...props} />,
    },
    {
      path: 'account/update',
      component: props => <ChangePassword {...props} />,
    },
    {
      path: 'account',
      component: props => <AccountSettingsContainer {...props} />,
    },
  ],
});
